/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getServicesRpc = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'getServices',
  auth: 'external',
  fingerprint: '2px9LAhjwB2WVLc1WsD9upwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getServiceByIdRpc = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'getServiceById',
  auth: 'external',
  fingerprint: 'RURPjuW49yx10AsEi57R0pwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getServicesPagedRpc = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'getServicesPaged',
  auth: 'external',
  fingerprint: 'dKC_3C9z82piYG15Za2blJwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getServicesByIdsRpc = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'getServicesByIds',
  auth: 'external',
  fingerprint: '_Xn4qIaXRLOWVLc1WsD9upwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createServiceRpc = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'createService',
  auth: 'external',
  fingerprint: '9wdEWhmVhU87FgX0XHMTNJwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateServiceRpc = {
  serviceName: 'com.hubspot.service.catalog.rpc.ServiceCatalogServiceRpc',
  rpcName: 'updateService',
  auth: 'external',
  fingerprint: 'CNczh3FVcM2sRYZeXeAB5pwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};